/**
 * Materiais do talabarte e da corda, para a força de choque: cada um com a
 * rigidez `EA` (a força que esticaria o material 100%, em kN), num arquivo de
 * dados, longe da lógica. A rigidez de um trecho de comprimento `L` é `EA / L`.
 *
 * TODOS os valores são PROVISÓRIOS (`confirmado: false`): são modelos lineares
 * ajustados a números públicos de ensaio, não a ficha de um produto. A corda
 * real endurece com a carga, perde elasticidade a cada queda, e os nós e as
 * costuras também absorvem energia. O instrutor confere e corrige aqui.
 */

export type MaterialTalabarte = 'fita-poliamida' | 'fita-dyneema' | 'corda-semiestatica' | 'corda-dinamica'

export interface DadosMaterial {
  readonly nome: string
  /** Rigidez do material: força (kN) que o esticaria 100%. */
  readonly rigidezEAkN: number
  /** De onde vem o número, e o que falta para confirmá-lo. */
  readonly origem: string
  readonly confirmado: boolean
}

export const MATERIAIS_TALABARTE: Readonly<Record<MaterialTalabarte, DadosMaterial>> = {
  'fita-poliamida': {
    nome: 'fita de poliamida',
    rigidezEAkN: 80,
    origem: 'Ajuste a ensaios publicados de fita costurada de poliamida: cerca de 12 kN numa queda de fator 1 com 80 kg. Conferir com o fabricante.',
    confirmado: false,
  },
  'fita-dyneema': {
    nome: 'fita de Dyneema',
    rigidezEAkN: 190,
    origem: 'Ajuste a ensaios publicados de fita de Dyneema de 60 cm: cerca de 18 kN numa queda de fator 1 com 80 kg. Conferir com o fabricante.',
    confirmado: false,
  },
  'corda-semiestatica': {
    nome: 'corda semiestática',
    rigidezEAkN: 40,
    origem: 'Ajuste para que 100 kg em queda de fator 0,3 fiquem perto de 6 kN, o ensaio da corda semiestática tipo A. Conferir na norma da corda e com o fabricante.',
    confirmado: false,
  },
  'corda-dinamica': {
    nome: 'corda dinâmica',
    rigidezEAkN: 21,
    origem: 'Ajuste à força de choque de catálogo de uma corda dinâmica simples (cerca de 8,5 kN com 80 kg em queda de fator 1,77). Conferir na ficha da corda.',
    confirmado: false,
  },
}

/** A ordem do parâmetro `materialTalabarte` do trabalhador (0, 1, 2, 3). */
export const ORDEM_MATERIAIS: readonly MaterialTalabarte[] = ['fita-poliamida', 'fita-dyneema', 'corda-semiestatica', 'corda-dinamica']

export function materialDoIndice(indice: number): MaterialTalabarte {
  return ORDEM_MATERIAIS[Math.min(ORDEM_MATERIAIS.length - 1, Math.max(0, Math.round(indice)))]!
}
